<template>
<div style="height:100%">
    <audio src="./../../assets/audio/go.mp3" id="go"  controls hidden='true' preload="auto" ref="go1" ></audio>
    <audio src="./../../assets/audio/bgmusic.mp3" id="bgmusic"  ref="bgmusic1" hidden='true' preload="auto" loop  autoplay controls></audio>
    <div class="gameIndex" v-if="pageFlag == 1">
        <div class="gameIndex_top">
            <div class="gameIndex_top_left">
                 <img src="@/assets/images/game/back.png" class="gameIndex_top_leftbac" @click="goBack" />
                 <img :src="headImg" class="gameIndex_top_leftpic" />
                 <p class="gameIndex_top_leftName">{{name}}</p>
            </div>
            <img src="@/assets/images/grow-club/emotion-people.png" class="gameIndex_top_right" />
        </div>
        <div class="gameIndex_bot">
            <div  :class="active<index+1?'gameIndex_bot_blank':''" class="gameIndex_bot_box" @click="goGame(index)"  v-for="(item, index) in gameList"  :key="index">
                <div class="ddd">
                    <p>{{index+1}}</p>
                    <div class="gameIndex_bot_box_starbox" v-if="active>index">
                        <img src="@/assets/images/game/star.png" class="gameIndex_bot_box_star gameIndex_bot_box_starone" v-if="item.scoreStars && item.scoreStars>0" />
                        <img src="@/assets/images/game/star.png" class="gameIndex_bot_box_star gameIndex_bot_box_startwo" v-if="item.scoreStars && item.scoreStars>1" />
                        <img src="@/assets/images/game/star.png" class="gameIndex_bot_box_star gameIndex_bot_box_starthree" v-if="item.scoreStars && item.scoreStars>2" />
                    </div>
                </div>
            </div>
        </div>
        <success-dialog :successShow='nextFlag' :gameType='gameType'></success-dialog>
    </div>
    <game v-if="pageFlag == 2" @gamegoback='gamegoback' @restart='restart' @next='next' @musicPause="musicPause" ></game>
</div>
</template>
<script>
import successDialog from './../../components/jigsaw/success-dialog.vue';
import { _getGameLevels } from '../../api/game';
import {horizontalScreen} from '../../assets/js/horizontal';
import game from './game.vue';
export default {
    data () {
        return {
            active:35,//已玩关卡
            nextFlag:false,//通关后返回关卡页面是否弹窗标识
            gameType:'2',//1-拼图，2-连连看
            gameList:[],//关卡列表
            headImg:'',//儿童头像
            name:'',//儿童昵称
            pageFlag:1,
        }
    },
    components:{
        successDialog,
        game,
    },
    mounted() {
        horizontalScreen();
         this.headImg = localStorage.getItem("headImg");
         this.name = localStorage.getItem("studentName");
         this.pageFlag = localStorage.getItem("pageFlag");
         this.$refs.bgmusic1.pause();
         if(this.pageFlag == 2) {
            this.$refs.bgmusic1.play();
         }
        //  this.nextFlag = JSON.parse(this.$route.query.nextFlag);
        //  setTimeout(()=>{
        //     this.nextFlag = false;
        // },5000);
        let childId = localStorage.getItem("childId");
        this.queryGameLevels(childId);
    },
    methods:{
        //游戏返回按钮
        goBack() {
            this.$router.push('emotion');
        },
        //重新开始
        restart() {
            this.$refs.bgmusic1.play();
        },
        //下一关
        next() {
            this.$refs.bgmusic1.play();
        },
        //返回
        gamegoback(val) {
            this.pageFlag = 1;
            localStorage.setItem('pageFlag',this.pageFlag);
            this.$refs.bgmusic1.pause();
            this.nextFlag = val;
            if(this.nextFlag) {
                setTimeout(()=>{
                    this.nextFlag = false;
                },5000);
            }
            let childId = localStorage.getItem("childId");
            this.queryGameLevels(childId);
            },
        //一小时时间限制
        musicPause() {
            this.$refs.go1.pause();
        },
        //关卡点击
        goGame(index) {
            if(this.active>=index+1) {
                // this.$router.push('game');
                this.$refs.bgmusic1.play();
                this.$refs.go1.play();
                localStorage.setItem('level', index+1);
                localStorage.setItem('flag', 1);
                this.pageFlag = 2;
                localStorage.setItem('pageFlag',this.pageFlag);
               
            }
        },
        // 获取游戏关卡
        queryGameLevels(childId) {
            _getGameLevels({gameType:'1',studentId:childId}).then(res=>{
                if(res.code == 200){
                    if(res.data && JSON.stringify(res.data) != "{}"){
                        let num =35 - res.data.length;
                        for(var i =0;i<num;i++){
                            this.gameList[i]={};
                            this.gameList[i].currentLevel = '';
                            this.gameList[i].isCurrentPassed = '';
                            this.gameList[i].scoreStars = '';
                            this.gameList[i].gameType = 1;
                        }
                        let list = res.data.reverse();
                        this.gameList = list.concat(this.gameList);
                        let currentLevel = Number(list[list.length-1].currentLevel);
                        let successFlag = list[list.length-1].isCurrentPassed;
                        this.active = successFlag ? (currentLevel < 35 ? currentLevel + 1 : 35): currentLevel;
                    }
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>
    .gameIndex {
      height: 100%;
      width: 100%;
      background: url(./../../assets/images/game/bac.png);
      background-size:100% 100%;
      .gameIndex_top {
          display: flex;
          justify-content: space-between;
          .gameIndex_top_left {
              margin: 15px 0 0 15px;
              display: flex;
              justify-content: center;
            .gameIndex_top_leftbac {
              width: 29px;
              height: 29px;
            }
            .gameIndex_top_leftpic {
                width: 40px;
                height: 40px;
                margin-left: 15px;
                border-radius:50% ;
            }
            .gameIndex_top_leftName {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF7C1F;
                line-height: 40px;
                margin-left: 10px;
            }
          }
          .gameIndex_top_right {
              width: 123px;
              height: 53px;
              margin: 10px 20px 0 0;
          }
      }
      .gameIndex_bot {
          width: 420px;
          height: 298px;
          background: url(./../../assets/images/game/game-bac.png);
          background-size:420px 298px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          align-items: center;
          .gameIndex_bot_box {
              width: 54px;
              height: 54px;
              margin-right: 7px;
              margin-bottom: 7px;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              p{
                  font-size: 20px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #FF7C1F;
                  margin-top: 2px;
                  text-align: center;
              }
              .gameIndex_bot_box_starbox {
                  display: flex;
                  justify-content: center;
                .gameIndex_bot_box_star {
                    width: 15px;
                    height: 18px;
                }
                .gameIndex_bot_box_starone {
                    margin-top: -5px;
                }
                .gameIndex_bot_box_starthree {
                    margin-top: -5px;
                }
              }
          }
          .gameIndex_bot_blank {
              background: #DEDEDE;
              opacity: 0.65;
          }
          .gameIndex_bot_box:nth-child(7n){
              margin-right: 0;
          }
      }
    }
</style>